import initialState from './initialState';
import { SET_SUBMISSIONS_TYPE } from '../actions/actionTypes';


export default function submissionsType(state = initialState.submissionsType, action) {
  switch (action.type) {
    case SET_SUBMISSIONS_TYPE:
      return action.setToVal;
    default:
      return state;
  }
}
